'use client';
import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import AppLayout from '@/components/AppLayout';

export default function QuemSomosPage() {
  const [visible, setVisible] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(timer);
  }, []);

  const paragraphs = [
    'A 1 dia de cada vez nasceu da percepção de que muitas pessoas estão enfrentando, em silêncio, dificuldades relacionadas ao vício em apostas online.',
    'Com a popularização das plataformas de apostas e cassinos digitais, milhares de pessoas passaram a lidar com perdas financeiras, ansiedade e a sensação de não conseguir parar.',
    'Mesmo sendo um problema crescente, ainda existem poucos espaços acessíveis e dedicados a ajudar quem deseja mudar essa realidade.',
    'A 1 dia de cada vez foi criada justamente para preencher essa lacuna: oferecer apoio, informação e um ambiente onde pessoas possam encontrar caminhos para reconstruir o controle sobre suas vidas.',
  ];

  return (
    <AppLayout>
      <div className="min-h-screen rounded-2xl" style={{ backgroundColor: '#1A1A2E', padding: '2rem 1.5rem' }}>
      <div
        ref={contentRef}
        className="max-w-2xl mx-auto pb-12"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 0.6s cubic-bezier(0.22,1,0.36,1), transform 0.6s cubic-bezier(0.22,1,0.36,1)',
        }}
      >
        {/* Header */}
        <div className="mb-12">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase mb-4 px-3 py-1 rounded-full"
            style={{ backgroundColor: 'rgba(124,158,135,0.15)', color: '#7C9E87' }}
          >
            Nossa História
          </span>
          <h1
            className="text-4xl md:text-5xl font-bold leading-tight mb-4"
            style={{ color: '#F8F7F4' }}
          >
            Quem Somos
          </h1>
          <div className="w-16 h-1 rounded-full" style={{ backgroundColor: '#C4A882' }} />
        </div>

        {/* Paragraphs */}
        <div className="space-y-6">
          {paragraphs?.map((text, i) => (
            <p
              key={i}
              className="text-base md:text-lg leading-relaxed"
              style={{
                color: i === 0 ? '#C4A882' : 'rgba(248,247,244,0.82)',
                fontWeight: i === 0 ? 600 : 400,
                fontSize: i === 0 ? '1.15rem' : undefined,
              }}
            >
              {text}
            </p>
          ))}
        </div>

        {/* Closing highlight */}
        <div
          className="mt-12 p-6 rounded-2xl border"
          style={{
            backgroundColor: 'rgba(124,158,135,0.08)',
            borderColor: 'rgba(124,158,135,0.25)',
          }}
        >
          <p
            className="text-base leading-relaxed mb-3"
            style={{ color: 'rgba(248,247,244,0.82)' }}
          >
            Se você está lutando contra o vício em jogos, saiba de uma coisa:
          </p>
          <p
            className="text-xl font-bold mb-4"
            style={{ color: '#7C9E87' }}
          >
            você não está sozinho.
          </p>
          <p
            className="text-base leading-relaxed mb-1"
            style={{ color: 'rgba(248,247,244,0.7)' }}
          >
            Hoje pode ser o primeiro passo.
          </p>
          <p
            className="text-lg font-semibold"
            style={{ color: '#C4A882' }}
          >
            Um dia de cada vez.
          </p>
        </div>

        {/* CTAs */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link
            href="/apoie-a-pagina"
            className="flex-1 text-center px-6 py-3.5 rounded-xl font-semibold text-sm transition-all duration-200 hover:opacity-80 border"
            style={{ borderColor: 'rgba(196,168,130,0.4)', color: '#C4A882' }}
          >
            Apoiar a Causa
          </Link>
        </div>
      </div>
      </div>
    </AppLayout>
  );
}
